import { atom } from "recoil";

export const optionAtom = atom({
  key: "options",
  default: [],
});
